export default function(state = null, action = {}) {

    switch (action.type) {

        case 'POINT_MAP_TO_COORDINATES':
			return angular.copy(action.coordinates);
        default:
            return state;
    }
}